import{a as y}from"./chunk-RAAYCPUM.js";function i(...e){return y(o,e)}function o(e,n){let t={};for(let r of n)r in e&&(t[r]=e[r]);return t}export{i as a};
